import React from 'react';
import HeroImage from 'Components/home/widgets/HeroImage';
import { Link } from 'react-router-dom';
import SignInForm from 'Components/home/SignInForm';
import * as actions from 'Actions';
import { connect } from 'react-redux';
import Imgix from 'react-imgix';
import { getSettingByUrl } from 'HelperFunctions/StorefrontPage';
import classNames from 'classnames';

const textColor = (value, dark = '#0E2C44') =>
  value === 'light' ? '#FFFFFF' : dark;

class SignIn extends React.Component {
  render() {
    const { errors, loginUser } = this.props;
    const {
      storefrontSetting,
      storefrontHomeSetting,
      storefrontEventsSetting,
      theme,
    } = this.props;

    const isElaina = theme === 'elaina';

    const { homeVisible, homeCarouselItems } = storefrontHomeSetting;
    const { pageBody, pageTitle, signinPicture } = storefrontSetting;
    const containsHomeImage = homeVisible && homeCarouselItems.length > 0;
    const customerPortalPicture = storefrontEventsSetting.customerPortalPicture;
    const displayPicture = customerPortalPicture || signinPicture;
    const displayTitle =
      storefrontEventsSetting.signinPageTitle || pageTitle || 'Sign In';
    const displayBody =
      storefrontEventsSetting.signinPageBody ||
      pageBody ||
      'Track rentals, make payments, request changes. You name it!';
    const headlineStyle = {
      color: textColor(storefrontEventsSetting.signinHeadlineTextColor),
    };
    const bodyStyle = {
      color: textColor(storefrontEventsSetting.signinBodyTextColor, '#466B88'),
    };

    const shouldNotDisplayFigure = isElaina && !containsHomeImage;

    return (
      <section
        className={classNames({
          signIn: true,
          authenticationNoImageContainer: shouldNotDisplayFigure,
        })}
      >
        {displayPicture ? (
          <figure>
            <Imgix
              src={displayPicture.imgixUrl}
              alt={displayTitle}
              width={1020}
              height={740}
            />
          </figure>
        ) : (
          <HeroImage shouldNotDisplayFigure={shouldNotDisplayFigure} />
        )}
        <div className={'details'}>
          <h1 style={headlineStyle}>{displayTitle}</h1>
          <p style={bodyStyle}>{displayBody}</p>
        </div>
        <div className={'signInForm'}>
          <SignInForm errors={errors} onSubmit={loginUser} />
          <Link to='/forgotPassword'>Forgot Password</Link>
          <Link to='/signUp'>Sign Up for FREE!</Link>
        </div>
      </section>
    );
  }
}

const mapStateToProps = (state, ownProps) => {
  const { parsedStorefrontSettings } = state.locations;
  const {
    mainSetting: { theme },
  } = parsedStorefrontSettings;
  const { location } = state.locations;
  const { errors, loading } = state.auth;
  // const storefrontSetting = parsedStorefrontSettings.mainSetting;
  const storefrontSetting = getSettingByUrl(
    location.storefrontPages,
    ownProps.location.pathname
  );

  return {
    theme,
    errors,
    loading,
    storefrontSetting: parsedStorefrontSettings.storefrontSigninSetting,
    storefrontEventsSetting: parsedStorefrontSettings.storefrontEventsSetting,
    storefrontHomeSetting: parsedStorefrontSettings.storefrontHomeSetting,
  };
};

export default connect(mapStateToProps, actions)(SignIn);
